<script setup lang="ts">
import { Inbox } from '@lucide/vue'
defineProps<{ title: string; description?: string; density?: 'compact' | 'default' }>()
</script>
<template>
  <section
    class="ui-empty-state"
    :class="`ui-empty-state--${density || 'default'}`"
  >
    <span
      class="ui-empty-icon"
      aria-hidden="true"
      ><slot name="icon"><Inbox :size="24" /></slot
    ></span>
    <h2>{{ title }}</h2>
    <p v-if="description">{{ description }}</p>
    <slot />
    <div
      v-if="$slots.actions"
      class="ui-header-actions"
    >
      <slot name="actions" />
    </div>
  </section>
</template>
